import { isInWxMP, isInAliMP, isInTtMP, encodeUrlSymbol } from './index'
import wx from 'weixin-js-sdk'

// 分享模板配置
export function miniAppShareConfig (data, sensors) {
  const shareOption = {
    title: data.title,
    path: `/pages/webview/index?url=${encodeURIComponent(encodeUrlSymbol(data.url))}`,
    imageUrl: data.img
  }
  try {
    if (isInWxMP()) {
      let wxSdk = window.wx
      if (!wxSdk || !wxSdk.miniProgram) {
        wxSdk = wx
        sensors.track('wx_sdk_config_test', {
          userAgent: navigator.userAgent,
          windowWxSdkMiniProgram: !!window.wx.miniProgram,
          wxSdkMiniProgram: !!wx.miniProgram
        })
      }
      wxSdk.miniProgram.postMessage({
        data: shareOption
      })
    }
    if (isInAliMP()) {
      window.my.postMessage({
        data: shareOption
      })
      return
    }
    if (isInTtMP()) {
      window.tt.miniProgram.postMessage({
        data: shareOption
      })
      return
    }
  } catch (ex) {
    console.error(ex)
  }
}
